export const environment = {
  production: false,
  analyticsEnvSuffix: '_STAGE',
  gaTrackingId: 'G-7TN9PBHZEF',
  apiUrl: "https://stage-api.lumberlinq.com/",
  shareUrl: "https://stage.lumberlinq.com/s/",
  forceRedirectUrl: "https://stage.lumberlinq.com/login?forceLogin=true",
  redirectUrl: "https://stage.lumberlinq.com/login?forceLogin=false",
  webUrl: "https://stage.lumberlinq.com/",
  cashfreeMode: "sandbox" as "sandbox" | "production",
  // Auth-cookie name suffix — MUST match backend CookieService.scopedName() (STAGE = "_stage").
  // Stops stage overwriting PROD auth cookie on the shared .lumberlinq.com parent domain.
  cookieSuffix: "_stage",
  logLevel: "DEBUG",
  baseUrl: "",
  httpProtocol: "https://",
  port: "",
  ipaddress: "stage-api.lumberlinq.com",
  turnstileSiteKey: "0x4AAAAAADccGy0yeGh8y3hN",
  sentryDsn: "", // empty = Sentry disabled on stage
  // Web push (browser) — from Firebase Console > Project Settings > General > Your apps > Web,
  // and > Cloud Messaging > Web Push certificates. Public client config, not secret (same status
  // as android/app/google-services.json) — safe to commit real values once obtained.
  firebaseWebConfig: {
    apiKey: "AIzaSyCca6OMHZVHf_e0RxvACZbnrpYYjIL7mQM",
    authDomain: "lumberlinq-5679.firebaseapp.com",
    projectId: "lumberlinq-5679",
    storageBucket: "lumberlinq-5679.firebasestorage.app",
    messagingSenderId: "145564962072",
    appId: "1:145564962072:web:f2d29bbd0f65cbf632626d",
    measurementId: "G-WBETTGS6ER",
  },
  vapidKey: "",
};

environment.baseUrl = environment.apiUrl;
